import React, { createRef, RefObject, useEffect, useState } from 'react';
import { styled as Styled } from '@nykaa/ui-components';
import { FormattedMessage } from '@nykaa/intl-shared';
import {
  LANG_SELECTOR_TOOLTIP_TITLE,
  LANG_SELECTOR_TOOLTIP_MESSAGE,
  LANG_SELECTOR_TOOLTIP_CONFIRMATION,
} from 'shared/constants/strings';
import { getCookie, setCookie } from 'helpers/utils/cookie';
import { pushEvent } from '@nykaa/data-layer/utils';
import { VRN_NUDGE_SHOWN } from 'shared/constants';
import useIntersectOutCallback from '@nykaa/utils/IObserver/userIntersectOutCallback';


interface WrapperProps {
  ref: RefObject<HTMLDivElement>
}

interface TooltipContentProps {
  onClick: () => void;
}

const Wrapper = Styled.div<WrapperProps>`
  width: 210px;
  margin: 16px;
`;

const Title = Styled.h3`
  color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.typography.bodyMedium};
`;

const Confirmation = Styled.h3`
  color: ${({ theme }) => theme.colors.primary}
`;

const Message = Styled.p`
  color: white;
  ${({ theme }) => theme.typography.bodySmall};
  margin: 8px 0;
`;

const DEFAULT_TITLE = 'Choose Language';
const DEFAULT_MESSAGE = 'Switch to your prefered language from here.';
const DEFAULT_CONFIRMATION = 'Got it!';
const tooltipCookie = 'HST';

const TooltipContent = ({ onClick }: TooltipContentProps) => {
  const isCookieSet = getCookie(tooltipCookie);
  const [hasSetCookie, setLocalCookie] = useState(isCookieSet);
  const educateUser = createRef();
  const setToolTipCookie = () => {
    if (!hasSetCookie) {
      setCookie(tooltipCookie, 1, 365);
      setLocalCookie(true);
    }
  };
  const viewable_threshold = 30;

  const [observerEducateUser] = useIntersectOutCallback(
    {},
    viewable_threshold,
    setToolTipCookie,
    () => {},
  );

  useEffect(() => {
    const container = (educateUser as RefObject<HTMLDivElement>)?.current;
    if (container) {
      const handleOutsideClick = (e) => {
        e.preventDefault();
        if (!container?.contains(e.target)) {
          onClick();
        }
      };
      document.body.addEventListener('click', handleOutsideClick);
      setTimeout(() => pushEvent(VRN_NUDGE_SHOWN, {
        vrnNudgeShown: 1,
      }), 500);
      return () => {
        onClick;
        document.body.removeEventListener('click', handleOutsideClick);
      };
    }
  }, [onClick, educateUser]);

  return (
    <Wrapper ref={educateUser as RefObject<HTMLDivElement>}>
      <Title ref={observerEducateUser as RefObject<HTMLDivElement>}>
        <FormattedMessage
          id={LANG_SELECTOR_TOOLTIP_TITLE}
          defaultMessage={DEFAULT_TITLE}
        />
      </Title>
      <Message>
        <FormattedMessage
          id={LANG_SELECTOR_TOOLTIP_MESSAGE}
          defaultMessage={DEFAULT_MESSAGE}
        />
      </Message>
      <Confirmation onClick={onClick}>
        <FormattedMessage
          id={LANG_SELECTOR_TOOLTIP_CONFIRMATION}
          defaultMessage={DEFAULT_CONFIRMATION}
        />
      </Confirmation>
    </Wrapper>
  );
};

export default TooltipContent;
